module.exports = __webpack_public_path__ + "img/2_128.3779a1d0.png";